import React from 'react';
import NoKHPL from './NoKHPL';
import KHPL from './KHPL';
import { useQuery } from 'react-query';
import { getKHPLLeads, getChannelPartners } from '../../api/services'; // Add API call for channel partners
import { LinearProgress } from '@mui/material';

const KHPLPage: React.FC = () => {
    // Fetch KHPL data
    const { data: KHPLData, isLoading: isLoadingKHPL, error: KHPLError, refetch: refetchKHPL } = useQuery('getKHPL', getKHPLLeads);

    const combinedData = [
        ...(KHPLData?.data || []), 
    ];


    if (combinedData.length === 0) {
        return <NoKHPL />;
    }

    return <KHPL KHPLData={combinedData} onDelete={() => { refetchKHPL();  }} />;
};

export default KHPLPage;
